/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BankTransferDTO } from './BankTransferDTO';
import type { MomoDTO } from './MomoDTO';
import type { OutBankTransferDTO } from './OutBankTransferDTO';
import type { PayerAccountRecord } from './PayerAccountRecord';
import type { PaymentLinkDTO } from './PaymentLinkDTO';
import type { QrCodeDTO } from './QrCodeDTO';
import type { RefundBankTransferDTO } from './RefundBankTransferDTO';
import type { SaleItemDTO } from './SaleItemDTO';
import type { UssdDTO } from './UssdDTO';

/**
 * Class that defines the relations of a operation
 */
export type OperationDTO = {
    /**
     * Indicates the name of the user who initiated the operation
     */
    collectedBy?: string;
    /**
     * Creation date
     */
    createdAt?: string;
    /**
     * Currency of the operation
     */
    currency?: string;
    /**
     * Until when a pending payment can still complete; for a cash or static account sale, the end of its confirmation window
     */
    expiresAt?: string;
    inBankTransfer?: BankTransferDTO;
    momo?: MomoDTO;
    /**
     * Id of this operation
     */
    operationId?: string;
    /**
     * Indicates if the money is flowing IN or OUT of the merchant account
     */
    operationType?: OperationDTO.operationType;
    outBankTransfer?: OutBankTransferDTO;
    payerAccount?: PayerAccountRecord;
    paymentLink?: PaymentLinkDTO;
    /**
     * Payment method of the operation
     */
    paymentMethod?: OperationDTO.paymentMethod;
    qrcode?: QrCodeDTO;
    refund?: RefundBankTransferDTO;
    /**
     * Sale items associated with this operation
     */
    saleItemDetail?: Array<SaleItemDTO>;
    /**
     * Indicates the sessionId of the transaction
     */
    sessionId?: string;
    /**
     * Indicates the status of the operation
     */
    status?: OperationDTO.status;
    /**
     * Indicates the total amount of the operation (includes fee)
     */
    totalAmount?: number;
    /**
     * Indicates the transaction id saved in external service
     */
    transactionId?: string;
    /**
     * Indicates the virtual account number the transaction was paid to
     */
    transferAccount?: string;
    ussd?: UssdDTO;
};

export namespace OperationDTO {

    /**
     * Indicates if the money is flowing IN or OUT of the merchant account
     */
    export enum operationType {
        IN = 'IN',
        OUT = 'OUT',
    }

    /**
     * Payment method of the operation
     */
    export enum paymentMethod {
        CASH = 'CASH',
        POS = 'POS',
        POS_ORDER = 'POS_ORDER',
        USSD = 'USSD',
        QR_CODE = 'QR_CODE',
        IN_BANK_TRANSFER = 'IN_BANK_TRANSFER',
        INWARDS_TRANSFER = 'INWARDS_TRANSFER',
        PAY_WITH_TRANSFER = 'PAY_WITH_TRANSFER',
        PAYMENT_LINK_PAY_WITH_TRANSFER = 'PAYMENT_LINK_PAY_WITH_TRANSFER',
        PAYMENT_LINK_USSD = 'PAYMENT_LINK_USSD',
        PAYMENT_LINK_CARD = 'PAYMENT_LINK_CARD',
        PAYMENT_LINK_QR_CODE = 'PAYMENT_LINK_QR_CODE',
        MOMO = 'MOMO',
        PAYMENT_LINK = 'PAYMENT_LINK',
        OUT_BANK_TRANSFER = 'OUT_BANK_TRANSFER',
        REFUND = 'REFUND',
        CARD = 'CARD',
        STATIC_ACCOUNT = 'STATIC_ACCOUNT',
    }

    /**
     * Indicates the status of the operation
     */
    export enum status {
        SUCCESS = 'SUCCESS',
        EXPIRED = 'EXPIRED',
        PENDING = 'PENDING',
        DECLINED = 'DECLINED',
        FAILED = 'FAILED',
        REVERSED = 'REVERSED',
    }
}